import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function listMarketingTemplates(salonId, token) {
  const res = await axios.get(`${API}/marketing/templates`, {
    params: { salon_id: salonId },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function listMarketingTemplatesByGoal(salonId, goal, token) {
  const res = await axios.get(`${API}/marketing/templates`, {
    params: { salon_id: salonId, goal },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function ensureDefaultEmailReminderTemplate(salonId, goal, token) {
  const res = await axios.post(
    `${API}/marketing/email-reminders/ensure-default-template`,
    {},
    {
      params: { salon_id: salonId, goal },
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function ensureDefaultRefillReminderTemplate(salonId, token) {
  return ensureDefaultEmailReminderTemplate(salonId, "REFILL_REMINDER", token);
}

export async function createMarketingTemplate(salonId, payload, token) {
  const res = await axios.post(`${API}/marketing/templates`, payload, {
    params: { salon_id: salonId },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateMarketingTemplate(templateId, payload, token) {
  const res = await axios.put(`${API}/marketing/templates/${templateId}`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function deleteMarketingTemplate(templateId, token) {
  const res = await axios.delete(`${API}/marketing/templates/${templateId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function duplicateMarketingTemplate(salonId, templateId, token) {
  const res = await axios.post(
    `${API}/marketing/templates/${templateId}/duplicate`,
    {},
    {
      params: { salon_id: salonId },
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function listMarketingCampaigns(salonId, params = {}, token) {
  const res = await axios.get(`${API}/marketing/campaigns`, {
    params: { salon_id: salonId, ...params },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createMarketingCampaign(salonId, payload, token) {
  const res = await axios.post(`${API}/marketing/campaigns`, payload, {
    params: { salon_id: salonId },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getMarketingCampaign(campaignId, token) {
  const res = await axios.get(`${API}/marketing/campaigns/${campaignId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateMarketingCampaign(campaignId, payload, token) {
  const res = await axios.put(`${API}/marketing/campaigns/${campaignId}`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function deleteMarketingCampaign(campaignId, token) {
  const res = await axios.delete(`${API}/marketing/campaigns/${campaignId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function archiveMarketingCampaign(campaignId, token) {
  const res = await axios.post(
    `${API}/marketing/campaigns/${campaignId}/archive`,
    {},
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function restoreMarketingCampaign(campaignId, token) {
  const res = await axios.post(
    `${API}/marketing/campaigns/${campaignId}/restore`,
    {},
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function previewCampaignRecipients(campaignId, token) {
  const res = await axios.post(
    `${API}/marketing/campaigns/${campaignId}/preview-recipients`,
    {},
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function listCampaignRecipients(campaignId, params = {}, token) {
  const res = await axios.get(`${API}/marketing/campaigns/${campaignId}/recipients`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function sendCampaignNow(campaignId, token) {
  const res = await axios.post(
    `${API}/marketing/campaigns/${campaignId}/send-now`,
    {},
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function cancelCampaign(campaignId, token) {
  const res = await axios.post(
    `${API}/marketing/campaigns/${campaignId}/cancel`,
    {},
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function getCampaignMetrics(campaignId, token) {
  const res = await axios.get(`${API}/marketing/campaigns/${campaignId}/metrics`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getCampaignReportSummary(payload, token) {
  const res = await axios.post(`${API}/reports/marketing-campaigns/summary`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getCampaignReportDetail(campaignId, token) {
  const res = await axios.post(
    `${API}/reports/marketing-campaigns/detail`,
    { campaign_id: campaignId },
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}
